import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { withLang } from "@/lib/langPath";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { stripLang } from "@/lib/langPath";

const PixelArrow = () => (
  <svg viewBox="0 0 12 12" className="h-3.5 w-3.5" fill="currentColor" shapeRendering="crispEdges">
    <rect x="1" y="5" width="7" height="2" />
    <rect x="7" y="3" width="2" height="1" />
    <rect x="7" y="8" width="2" height="1" />
    <rect x="9" y="5" width="2" height="2" />
  </svg>
);

const FloatingCTA = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [onBlue, setOnBlue] = useState(false);
  const { pathname } = useLocation();
  const isRetail = stripLang(pathname).startsWith("/retail");
  const isIndustrial = stripLang(pathname).startsWith("/industrial");
  const label = t("sChrome.floatingCta.study");
  const navigate = useNavigate();
  const handleClick = () => navigate(withLang("/estudio-implantacion"));


  useEffect(() => {
    const onScroll = () => {
      const pastHero = window.scrollY > window.innerHeight * 0.35;

      // hide as soon as the footer (or a closing CTA block) enters the viewport
      const blockers = [
        document.getElementById("site-footer"),
        ...Array.from(document.querySelectorAll<HTMLElement>("[data-hide-cta]")),
      ].filter(Boolean) as HTMLElement[];
      const footerVisible = blockers.some(
        (el) => el.getBoundingClientRect().top < window.innerHeight - 16
      );

      setVisible(pastHero && !footerVisible);

      const y = window.innerHeight - 60;
      let over = false;
      document.querySelectorAll<HTMLElement>('[data-header-theme="blue"]').forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < y && r.bottom > y - 40) over = true;
      });
      setOnBlue(over);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed right-4 bottom-4 z-40 md:right-6 md:bottom-6"
        >
          <span className="relative flex">
            <span
              className={`absolute -inset-1 rounded-none opacity-15 blur-md animate-[pulse_3.5s_cubic-bezier(0.4,0,0.6,1)_infinite] ${
                onBlue ? "bg-white" : isRetail ? "bg-retail" : isIndustrial ? "bg-industrial" : "bg-brand-blue"
              }`}
              aria-hidden="true"
            />
            <button
              type="button"
              onClick={handleClick}
              className={`relative inline-flex items-center gap-3 rounded-none pl-6 pr-2 py-2 text-sm md:text-base text-black transition-transform duration-300 hover:scale-[1.03] ${
                onBlue ? "bg-white" : isRetail ? "bg-retail" : isIndustrial ? "bg-industrial" : "bg-brand-blue"
              }`}
            >
              {label}
              <span
                className={`inline-flex h-9 w-9 items-center justify-center rounded-none bg-black ${
                  onBlue ? "text-white" : isRetail ? "text-retail" : isIndustrial ? "text-industrial" : "text-brand-blue"
                }`}
              >
                <PixelArrow />
              </span>
            </button>
          </span>

        </motion.div>
      )}
    </AnimatePresence>
  );
};



export default FloatingCTA;
